<template>
  <div>
    <div class="items mt-40">
      <el-row
        type="flex"
        justify="space-between"
        class="item pb-20"
      >
        <span class="item-property">
          {{ $t('profile.first-name') }}
        </span>
        <span class="item-value">
          {{ user.name }}
        </span>
      </el-row>
      <el-row
        type="flex"
        justify="space-between"
        class="item pt-20 pb-20"
      >
        <span class="item-property">
          {{ $t('profile.last-name') }}
        </span>
        <span class="item-value">
          {{ user.surName }}
        </span>
      </el-row>
      <el-row
        type="flex"
        justify="space-between"
        class="item pt-20 pb-20"
      >
        <span class="item-property">
          {{ $t('profile.phone') }}
        </span>
        <span class="item-value">
          {{ user.phoneNum }}
        </span>
      </el-row>
      <el-row
        type="flex"
        justify="space-between"
        class="item pt-20 pb-20"
      >
        <span class="item-property">
          {{ $t('profile.email') }}
        </span>
        <span class="item-value">
          {{ user.email }}
        </span>
      </el-row>
      <el-row
        type="flex"
        justify="space-between"
        class="item pt-20 pb-20"
      >
        <span class="item-property iban">
          <el-tooltip
            v-if="user.ibanStatus === 'false'"
            :content="$t('profile.iban-contact-support')"
            placement="top"
          >
            <i class="el-icon-circle-close" />
          </el-tooltip>
          <el-tooltip
            v-else
            :content="$t('profile.iban-connected')"
            placement="top"
          >
            <i class="el-icon-circle-check" />
          </el-tooltip>
          {{ $t('profile.iban') }}
        </span>
        <span class="item-value">
          {{ user.iban }}
        </span>
      </el-row>
    </div>
    <el-row class="buttons mt-20">
      <el-col
        :span="11"
      >
        <router-link
          :to="{name: 'EditUser', params: { userId: this.user.sub }}"
          custom
          v-slot="{ navigate }"
        >
          <el-button
            type="primary"
            class="primary-button edit-profile-btn"
            @click="navigate"
          >
            {{ $t('profile.edit-profile') }}
          </el-button>
        </router-link>
      </el-col>
      <el-col
        :offset="2"
        :span="11"
      >
        <router-link
          :to="{name: 'ChangePassword'}"
          custom
          v-slot="{ navigate }"
        >
          <el-button
            type="primary"
            class="primary-button change-password-btn"
            @click="navigate"
          >
            {{ $t('profile.change-password') }}
          </el-button>
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style scoped lang="scss">
.items {
  .item {
    border-bottom: 1px solid #e5e5e5;

    &-property {
      font-family: "Raleway Regular", serif;
      font-size: 16px;

      .el-icon-circle-close {
        font-size: 20px;
        color: #F56C6C;
      }

      .el-icon-circle-check {
        font-size: 20px;
        color: #1F9F43;
      }
    }

    &-value {
      font-family: "Raleway Bold", serif;
      font-size: 16px;
    }
  }
}

.edit-profile-btn, .change-password-btn {
  @media(max-width: 768px) {
    font-size: 14px;
  }
}
</style>
